<app-header></app-header>
<app-banner></app-banner>
<app-product-info></app-product-info>
<app-features></app-features>
<app-partners></app-partners>
<app-footer></app-footer>
